/**
 * The small pieces the sweep is built out of: the outline's own geometry, the frame basis every
 * extrusion step is placed on, and the once-per-session approximation warnings. Part of the
 * CSGPolygon3D port, whose derivation notice is in `polygonGeometry.ts`.
 */
import * as THREE from 'three';
/**
 * The owner of the sweep's approximation warnings. The builder runs on every geometry rebuild, so
 * each warns once for the session, not once per keystroke in the source pane.
 */
export const SWEEP_WARNINGS = {};
export function toPoints(flat) {
    const out = [];
    for (let i = 0; i + 1 < flat.length; i += 2)
        out.push(new THREE.Vector2(flat[i], flat[i + 1]));
    return out;
}
/** Godot passes `Vector3(0, 1, 0)` as the up vector for every PATH frame. */
export const PATH_UP = new THREE.Vector3(0, 1, 0);
/** `Transform3D().looking_at(dir, up)`, which is three's `lookAt` with the same convention. */
export function facingMatrix(dir, up) {
    const m = new THREE.Matrix4();
    // A zero or up-parallel direction makes the basis degenerate in Godot too; identity is
    // the least-surprising fallback and keeps NaN out of the vertex buffer.
    if (dir.lengthSq() === 0)
        return m;
    const safeUp = Math.abs(dir.clone().normalize().dot(up)) > 0.9999 ? new THREE.Vector3(0, 0, 1) : up;
    return m.lookAt(new THREE.Vector3(0, 0, 0), dir, safeUp);
}
//# sourceMappingURL=polygonSweepFrames.js.map